import "../../../styles/QuoteStyles/Overlays/Successoverlay.css";

interface SuccessOverlayProps {
  onClose: () => void;
}

export default function SuccessOverlay({ onClose }: SuccessOverlayProps) {
  return (
    <div className="overlay-backdrop" onClick={onClose}>

      {/* Stop click inside card from closing overlay */}
      <div className="overlay-card" onClick={e => e.stopPropagation()}>

        {/* Animated checkmark */}
        <div className="overlay-icon">
          <svg viewBox="0 0 52 52" className="checkmark-svg">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
            <path className="checkmark-tick" fill="none" d="M14 27 l8 8 l16 -16" />
          </svg>
        </div>

        {/* Text */}
        <h2 className="overlay-title">Request Submitted!</h2>
        <p className="overlay-desc">
          Your quote request has been received. We will contact you via email or phone shortly.
        </p>

        {/* Info row */}
        <div className="overlay-info">
          <div className="overlay-info-item">
            <span className="overlay-info-icon">📧</span>
            <span>A consultant will reply by email or phone</span>
          </div>
          <div className="overlay-info-item">
            <span className="overlay-info-icon">⏱️</span>
            <span>Response within 1–2 business days</span>
          </div>
          <div className="overlay-info-item">
            <span className="overlay-info-icon">💬</span>
            <span>WhatsApp opened with your request. Press send there to reach us faster.</span>
          </div>
        </div>

        {/* Actions */}
        <div className="overlay-actions">
          <button className="overlay-btn-primary" onClick={onClose}>
            Done
          </button>
        </div>

      </div>
    </div>
  );
}